import script from "./Warehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./Warehouse.vue?vue&type=script&setup=true&lang=js"

import "./Warehouse.vue?vue&type=style&index=0&id=21d21845&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d21845"]])

export default __exports__